import confetti from 'canvas-confetti';
import type { configObj } from 'js-chess-engine';
import {
  FC,
  memo,
  MouseEventHandler,
  useContext,
  useEffect,
  useState
} from 'react';
import { useCatchKeyboardPress } from '../Hooks';
import { cxChessdata } from './Chessdata';
import Modal from './Modal';

const ModalFinishGame: FC = () => {
  const winAudio = new Audio('/getflix/game/catur/sounds/champ.mp3');
  winAudio.volume = 0.2;
  const { data } = useContext(cxChessdata);
  const [open, setOpen] = useState(false);
  useEffect(() => {
    if (data == null) return;
    let openModal = data.isFinished && data.fullMove > 1;
    setOpen(openModal);
    if (openModal) {
      confetti({});
      winAudio.play();
    }
  }, [data]);

  const onCloseHandler: MouseEventHandler<HTMLButtonElement> = () => {
    setOpen(false);
  };
  useCatchKeyboardPress(() => {
    if (!open) return null;
    setOpen(false);
  }, ['Escape']);

  if (!open) return null;
  let winner: configObj['turn'] = !data!.checkMate
    ? data!.turn
    : data!.turn === 'black'
    ? 'white'
    : 'black';
  const title = `${winner} Menang 🎉`;
  const body = `${winner} Menang dalam ${data?.fullMove} langkah`;
  return <Modal onCloseHandler={onCloseHandler} body={body} title={title} />;
};

export default memo(ModalFinishGame);
